"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDeprecatedPropsWarning = exports.withDeprecatedComponentWarning = exports.printDeprecationWarning = exports.printComponentDeprecationWarning = exports.printPropDeprecationWarning = exports.useDeprecatedPropsWarning = exports.useDeprecatedComponentWarning = void 0;

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.object.keys.js");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _react = _interopRequireWildcard(require("react"));

/* eslint-disable no-console */
var IS_DEV = process.env.NODE_ENV !== 'production';
/**
 * Util to isolate logging and do the production check only once.
 */

var logWarning = function logWarning(message) {
  if (IS_DEV) {
    console.warn(message);
  }
};
/**
 * Util to generate a standardized deprecation message. Takes
 * an options object as input and returns a string.
 */


var propDeprecationMessage = function propDeprecationMessage(_ref) {
  var componentName = _ref.componentName,
      version = _ref.version,
      deprecated = _ref.deprecated,
      migration = _ref.migration;
  return "".concat(componentName, " ").concat(version ? "v".concat(version, "+ ") : '', "has deprecated the ").concat(deprecated, " prop. ").concat(migration || '', " See the CHANGELOG.md for details.");
};
/**
 * console.error if prop is deprecated. Takes an array describing the
 * deprecated props and how to migrate away from them.
 *
 * @param componentName name of the component
 * @param deprecatedProps collection of props to deprecate
 * @param currentProps props to check for deprecation
 */


var printPropDeprecationWarning = function printPropDeprecationWarning(componentName, deprecatedProps, currentProps) {
  if (!deprecatedProps || deprecatedProps.length === 0) {
    throw new Error('an array of deprecated props must be supplied to the deprecate util.');
  }

  deprecatedProps.forEach(function (prop) {
    var deprecated = prop.deprecated,
        migration = prop.migration,
        version = prop.version;

    if (currentProps && currentProps[deprecated]) {
      var deprecatedMessage = propDeprecationMessage({
        componentName: componentName,
        deprecated: deprecated,
        migration: migration,
        version: version
      });
      logWarning(deprecatedMessage);
    }
  });
};
/**
 * console.error if component is deprecated or
 * deprecated props have been used in the component.
 * Handles current props and nextProps.
 *
 * Util to generate a standardized deprecation message. Takes
 * an options object as input and returns a string.
 *
 * @param options.component name of the component
 * @param options.version since being deprecated
 * @param options.migration message to what to migrate to
 */


exports.printPropDeprecationWarning = printPropDeprecationWarning;

var printComponentDeprecationWarning = function printComponentDeprecationWarning(_ref2) {
  var component = _ref2.component,
      version = _ref2.version,
      migration = _ref2.migration;

  if (!component) {
    throw new Error('component must be supplied to the deprecate util.');
  }

  logWarning("".concat(component, " ").concat(version ? " v".concat(version, "+ ") : '', "has been deprecated. ").concat(migration || '', " See the CHANGELOG.md for details."));
};
/**
 * Generic deprecation warning that accepts any message.
 */


exports.printComponentDeprecationWarning = printComponentDeprecationWarning;

var printDeprecationWarning = function printDeprecationWarning(_ref3) {
  var message = _ref3.message;
  logWarning(message);
};
/**
 * Returns the name of the given component.
 */


exports.printDeprecationWarning = printDeprecationWarning;

var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};
/**
 * Hook to add deprecated component warning to functional component.
 */


var useDeprecatedComponentWarning = function useDeprecatedComponentWarning(_ref4) {
  var component = _ref4.component,
      version = _ref4.version,
      migration = _ref4.migration;
  (0, _react.useEffect)(function () {
    printComponentDeprecationWarning({
      component: component,
      version: version,
      migration: migration
    });
  }, // Even if the props change, we only want to print this warning once.
  // So, we deliberately don't re-run this effect when its dependencies
  // change.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
};
/**
 * Higher Order Component to indicate the wrapped component as deprecated
 */


exports.useDeprecatedComponentWarning = useDeprecatedComponentWarning;

var withDeprecatedComponentWarning = function withDeprecatedComponentWarning() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      version = _ref5.version,
      migration = _ref5.migration;

  return function (Component) {
    var WrappedComponent = function WrappedComponent(props) {
      useDeprecatedComponentWarning({
        component: getDisplayName(Component),
        version: version,
        migration: migration
      });
      return /*#__PURE__*/_react.default.createElement(Component, props);
    };

    WrappedComponent.displayName = "Deprecated(".concat(getDisplayName(Component), ")");
    return WrappedComponent;
  };
};
/**
 * Hook to add deprecated props warning to functional component.
 */


exports.withDeprecatedComponentWarning = withDeprecatedComponentWarning;

var useDeprecatedPropsWarning = function useDeprecatedPropsWarning(_ref6) {
  var component = _ref6.component,
      deprecatedProps = _ref6.deprecatedProps,
      props = _ref6.props;

  var _useRef = (0, _react.useRef)([]),
      seenProps = _useRef.current;

  var propsToWatch = deprecatedProps.map(function (prop) {
    return props[prop.deprecated];
  });
  (0, _react.useEffect)(function () {
    // remove props that were already seen
    var unseenProps = (0, _omit2.default)(props, seenProps);
    printPropDeprecationWarning(component, deprecatedProps, unseenProps);
    seenProps.push.apply(seenProps, (0, _toConsumableArray2.default)(Object.keys(unseenProps)));
  }, // There's two separate lint violations we're ignoring here:
  // 1) The rule complains that we're not passing a static array, so it can't
  //    be statically analyzed. That's an inherent part of the way this hook
  //    functions, so we'll ignore it.
  // 2) The rule complains that `component`, `deprecatedProps`, `props`, and
  //    `seenProps` aren't specified in the dependency array. This is
  //    acceptable.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  propsToWatch);
};
/**
 * Higher Order Component to indicate the wrapped component as deprecated props.
 *
 * @param deprecatedProps collection of props to deprecate
 */


exports.useDeprecatedPropsWarning = useDeprecatedPropsWarning;

var withDeprecatedPropsWarning = function withDeprecatedPropsWarning(deprecatedProps) {
  return function (Component) {
    var WrappedComponent = function WrappedComponent(props) {
      useDeprecatedPropsWarning({
        component: getDisplayName(Component),
        deprecatedProps: deprecatedProps,
        props: props
      });
      return /*#__PURE__*/_react.default.createElement(Component, props);
    };

    WrappedComponent.displayName = "Deprecated[".concat(deprecatedProps.map(function (prop) {
      return prop.deprecated;
    }), "](").concat(getDisplayName(Component), ")");
    return WrappedComponent;
  };
};

exports.withDeprecatedPropsWarning = withDeprecatedPropsWarning;